$(document).ready((function(){$(".custom_page_popup").length&&($("body").on("click",".open_page_modal_button",(function(o){o.preventDefault();var p=$(this).attr("data-block-id");var a=$("#custom_page_popup_"+p);a.length&&(a.addClass("active"),$("body").addClass("showCustom_page_popup"))})),$("body").on("click",".custom_page_popup__close",(function(o){o.preventDefault();var p=$(this).closest(".custom_page_popup");p.length&&(p.removeClass("active"),$("body").removeClass("showCustom_page_popup"))})),$(document).click((function(o){var p=$(".custom_page_popup__wrapper");var a=o.target;if(0===p.has(a).length&&!$(a).hasClass("open_page_modal_button")&&!$(a).hasClass("custom_page_popup__wrapper")){var e=$(".custom_page_popup.active");e.length&&(e.removeClass("active"),$("body").removeClass("showCustom_page_popup"))}})));var o=$(".product-form .product-form__image");o.length&&$(window).scroll((function(){var p=o.offset().top;var a=o.offset().top+o.outerHeight();var e=$(window).scrollTop()+$(window).innerHeight();var t=$(window).scrollTop();e>p&&t<a&&o.addClass("visible_block")}))}));
//# sourceMappingURL=/s/files/1/0257/1730/9521/t/17/assets/custom.js.map?v=17652964780161519487

// js/sections/before-after-image.js
var SplitCursor = class extends HTMLElement {
  connectedCallback() {
    this._parentSection = this.closest(".shopify-section");
    this._dragging = false;
    this._offsetX = this._currentX = 0;
    this._parentSection.addEventListener("pointerdown", this._onPointerDown.bind(this));
    this._parentSection.addEventListener("pointermove", this._onPointerMove.bind(this));
    this._parentSection.addEventListener("pointerup", this._onPointerUp.bind(this));
    window.addEventListener("resize", this._recalculateOffset.bind(this));
  }
  get minOffset() {
    return -this.offsetLeft - (document.dir === "rtl" ? this.clientWidth : 0);
  }
  get maxOffset() {
    return this.offsetParent.clientWidth + this.minOffset;
  }
  _onPointerDown(event) {
    if (event.target === this || this.contains(event.target)) {
      this._initialX = event.clientX - this._offsetX;
      this._dragging = true;
    }
  }
  _onPointerMove(event) {
    if (!this._dragging) {
      return;
    }
    this._currentX = Math.min(Math.max(event.clientX - this._initialX, this.minOffset), this.maxOffset);
    this._offsetX = this._currentX;
    this._parentSection.style.setProperty("--clip-path-offset", `${this._currentX.toFixed(1)}px`);
  }
  _onPointerUp() {
    this._dragging = false;
  }
  _recalculateOffset() {
    this._parentSection.style.setProperty("--clip-path-offset", `${Math.min(Math.max(this.minOffset, this._currentX.toFixed(1)), this.maxOffset)}px`);
  }
};
if (!window.customElements.get("split-cursor")) {
  window.customElements.define("split-cursor", SplitCursor);
}




// js/sections/countdown-timer.js
var CountdownTimer = class extends HTMLElement {
  connectedCallback() {
    
    const _this = this;
  
    let countdown_timerEl = this.querySelector(".countdown_timer");
    if(countdown_timerEl) {
      const dateStr = _this.getAttribute('data-time');
      const use_short_style =  (_this.getAttribute('data-use_short_style') === 'true'); 
      
      let countDownDate = new Date(dateStr).getTime();
      if(dateStr == '0') {
         countDownDate = new Date().setHours(23,59,59,999);
      }

      const timerDaysElem = this.querySelector('.timer-days .timer-value');
      const timerDaysLabelElem = this.querySelector('.timer-days .timer-label');
      
      const timerHoursElem = this.querySelector('.timer-hours .timer-value');
       const timerHoursLabelElem = this.querySelector('.timer-hours .timer-label');
      
      const timerMinutesElem = this.querySelector('.timer-minutes .timer-value');
      const timerMinutesLabelElem = this.querySelector('.timer-minutes .timer-label');
      
      const timerSecondsElem = this.querySelector('.timer-seconds .timer-value');
      const timerSecondsLabelElem = this.querySelector('.timer-seconds .timer-label');
      

      let x = setInterval(function() {
        let now = new Date().getTime();
        let distance = countDownDate - now;
        
        if(distance <= 0) {
          
            clearInterval(x);
            if(_this) {
              _this.style.display = 'none';

              if(_this.closest('.richtext_timer_block')) {
                _this.closest('.richtext_timer_block').style.display = 'none';
              }
                       if(_this.closest('.offer')) {
                _this.closest('.offer').style.display = 'none';
              }

              
            }
          
        }


        if(distance >= 0) {
          let days = Math.floor(distance / (1000 * 60 * 60 * 24));
          let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          let seconds = Math.floor((distance % (1000 * 60)) / 1000);



          if(timerDaysLabelElem) {
            if(days == 1) {
              timerDaysLabelElem.innerHTML =   window.themeVariables.strings.timer_day;
            } else {
              timerDaysLabelElem.innerHTML = window.themeVariables.strings.timer_days;
            }
          }

          if(timerHoursLabelElem) {
          if(use_short_style) {
           timerHoursLabelElem.innerHTML =   window.themeVariables.strings.timer_short_hours;
          } else {
             if(hours == 1) {
              timerHoursLabelElem.innerHTML =   window.themeVariables.strings.timer_hour;
            } else {
              timerHoursLabelElem.innerHTML = window.themeVariables.strings.timer_hours;
            }
          }
          }

          if(timerMinutesLabelElem) {
           if(use_short_style) {
           timerMinutesLabelElem.innerHTML =   window.themeVariables.strings.timer_short_minutes;
          } else {
              timerMinutesLabelElem.innerHTML =   window.themeVariables.strings.timer_minutes;
          }
          }


          if(timerSecondsLabelElem) {
           if(use_short_style) {
           timerSecondsLabelElem.innerHTML =   window.themeVariables.strings.timer_short_seconds;
          } else {
            timerSecondsLabelElem.innerHTML =   window.themeVariables.strings.timer_seconds;
          }
          }
          
          
          
          if(days < 10) {
            days = "0"+days;
          }
          if(hours < 10) {
            hours = "0"+hours;
          }
          if(minutes < 10) {
            minutes = "0"+minutes;
          }
          if(seconds < 10) {
            seconds = "0"+seconds;
          }

        

          timerDaysElem.innerHTML = days;
          timerHoursElem.innerHTML = hours;
          timerMinutesElem.innerHTML = minutes;
          timerSecondsElem.innerHTML = seconds;
        }
      },1000);

    }

  }

};
if (!window.customElements.get("countdown-timer")) {
  window.customElements.define("countdown-timer", CountdownTimer);
}






document.addEventListener('click', function(e) {
    let el = e.target;

    if (el.classList.contains('hot-spot__dot') || el.closest('.hot-spot__dot')) {
        if (!el.classList.contains('hot-spot__dot')) {
            el = el.closest('.hot-spot__dot');
        }

        e.preventDefault();
        let popoverId = el.getAttribute('aria-controls');
        let PopoverEl = document.querySelector('#' + popoverId);
        let parentEl = el.closest('.shopify-section--hot-spots');

        if (PopoverEl) {

          
            let isActive = el.classList.contains('active');
            if (!isActive) {
                PopoverEl.style.display = 'block';

              document.body.classList.add('active_hotspot_popover');

                let activePrevPopover = parentEl.querySelector('.popover.active');
                if (activePrevPopover) {
                    activePrevPopover.classList.remove('active');

                    let activePrevHotspot = parentEl.querySelector('.hot-spot__dot.active');
                    if (activePrevHotspot) {
                        activePrevHotspot.setAttribute('aria-expanded', 'false');
                        activePrevHotspot.classList.remove('active');

                      if (window.matchMedia("screen and (max-width: 999px)").matches) {
                      activePrevHotspot.parentNode.insertBefore(activePrevPopover, activePrevHotspot.nextSibling);
                      }

                    }

                }

                if (window.matchMedia("screen and (max-width: 999px)").matches) {

                  document.body.append(PopoverEl);
                  
                    PopoverEl.style.left = "0px";
                    PopoverEl.style.right = null;
                    PopoverEl.style.bottom = "0px";
                    PopoverEl.style.top = null;

                } else {
                    let spacingBlockValue = "var(--popover-anchor-block-spacing)",
                        spacingInlineValue = "var(--popover-anchor-inline-spacing)";

                    let vertical = PopoverEl.getAttribute("anchor-vertical") || "start",
                        horizontal = PopoverEl.getAttribute("anchor-horizontal") || "end";

                    PopoverEl.style.left = horizontal === "start" ? spacingInlineValue : null;
                    PopoverEl.style.right = horizontal === "end" ? spacingInlineValue : null;
                    if (vertical === "center") {
                        PopoverEl.style.top = `calc(50% - ${parseInt(PopoverEl.clientHeight / 2)}px)`;
                        PopoverEl.style.bottom = null;
                    } else {
                        PopoverEl.style.top = vertical === "end" ? `calc(100% + ${spacingBlockValue})` : null;
                        PopoverEl.style.bottom = vertical === "start" ? `calc(100% + ${spacingBlockValue})` : null;
                    }
                }

                setTimeout(function () {
                PopoverEl.classList.add('active');
                el.setAttribute('aria-expanded', 'true');
                el.classList.add('active');
                },0);
      
            } else {
                PopoverEl.classList.remove('active');
                el.setAttribute('aria-expanded', 'false');
                el.classList.remove('active');
               document.body.classList.remove('active_hotspot_popover');

                    if (window.matchMedia("screen and (max-width: 999px)").matches) {
                        setTimeout(function () {
                      el.parentNode.insertBefore(PopoverEl, el.nextSibling);
                      },0);
                      }
            }
        }
    }
});
function closeActiveHotSpotPopover () {
  const activePopover = document.querySelector('.hot-spot-popover.active');
 
  if(activePopover) {
    let popoverId = activePopover.id
    let popoverTriggerButton = document.querySelector('.hot-spot__dot[aria-controls="'+popoverId+'"');
    if(popoverTriggerButton) {
         activePopover.classList.remove('active');
                popoverTriggerButton.setAttribute('aria-expanded', 'false');
                popoverTriggerButton.classList.remove('active');
               document.body.classList.remove('active_hotspot_popover');
        popoverTriggerButton.parentNode.insertBefore(activePopover, popoverTriggerButton.nextSibling);
    }
  }
  
};

document.addEventListener('click', function(e){
  	var el = e.target;
    if (window.matchMedia("screen and (max-width: 999px)").matches) {
   if (el.classList.contains('close_mobile_hotspot_popover') || el.closest('.close_mobile_hotspot_popover') || el.classList.contains('active_hotspot_popover') ) {
     closeActiveHotSpotPopover();
  }
} 
  });



// js/common/behavior/custom-cursor.js
var CustomCursor = class extends HTMLElement {
  constructor() {
    super(...arguments);
  }
  connectedCallback() {

    this.parentElement.addEventListener("pointermove", onPointerMove.bind(this));
    this.parentElement.addEventListener("pointerleave",onPointerLeave.bind(this));
  }

};

function onPointerLeave () {
  this.classList.remove("is-visible", "is-half-start", "is-half-end");
};

function onPointerMove (event) {
  if (event.target.matches("button, a[href], button :scope, a[href] :scope")) {
    return this.classList.remove("is-visible");
  }
  const parentBoundingRect = this.parentElement.getBoundingClientRect(), 
    parentXCenter = (parentBoundingRect.left + parentBoundingRect.right) / 2, 
    isOnStartHalfPart = event.pageX < parentXCenter;
  this.classList.toggle("is-half-start", isOnStartHalfPart);
  this.classList.toggle("is-half-end", !isOnStartHalfPart);
  this.classList.add("is-visible");
  const mouseY = event.clientY - parentBoundingRect.y - this.clientHeight / 2, mouseX = event.clientX - parentBoundingRect.x - this.clientWidth / 2;
  this.style.translate = `${mouseX.toFixed(3)}px ${mouseY.toFixed(3)}px`;
  this.style.transform = `${mouseX.toFixed(3)}px ${mouseY.toFixed(3)}px`;
};
if (!window.customElements.get("custom-cursor")) {
  window.customElements.define("custom-cursor", CustomCursor);
}

var ImpactText = class extends HTMLElement {
  constructor() {
    super(...arguments);
  }
  connectedCallback() {
    if (this.hasAttribute('count-up')) {
      let textMain = this.querySelector('.text-wrapper');
   
      let textMainSymbols = textMain.textContent.split('');
      
      let textAnimatedString = '';
      let duration = +this.getAttribute('count-up');

      let textNonAnimatedStringArr = [];
      
      for (let i = 0; i < textMainSymbols.length; i++) {

        if (/^\d+$/.test(textMainSymbols[i]) == true || /\s/.test(textMainSymbols[i]) == true) {
          textAnimatedString = textAnimatedString + textMainSymbols[i];
        } else {
           textNonAnimatedStringArr.push(textMainSymbols[i]);
        }
      }

  
      if (textAnimatedString != '') {
        let textNonAnimatedString = textMainSymbols.join('').replace(textAnimatedString, "");
        console.log(textNonAnimatedString + ' textNonAnimatedString');
        console.log(textAnimatedString + ' textAnimatedString');

if(textNonAnimatedStringArr.length == 1)          {
        textMain.innerHTML = '<span>' + textAnimatedString + '</span>' + textNonAnimatedString;  
} else {
    textMain.innerHTML =  textNonAnimatedStringArr[0] + '<span>' + textAnimatedString + '</span>' + textNonAnimatedStringArr[1];  
}
      } 
  
      let textAnimatedEl = this.querySelector('.text-wrapper > span');
      let animationStart = false;
      if (textAnimatedEl != null) {
        let numbersArr = textAnimatedEl.textContent.split(' ');

        
        textAnimatedEl.innerHTML = '';
        for (let i = 0; i < numbersArr.length; i++) {
          if (numbersArr[i] != '') {
            textAnimatedEl.innerHTML = textAnimatedEl.innerHTML + ' <span>' + numbersArr[i] + '</span>';
          } else {
            textAnimatedEl.innerHTML = textAnimatedEl.innerHTML + numbersArr[i] + ' ';
          }
        }
        let numElements = textAnimatedEl.querySelectorAll('span');
        
        document.addEventListener('scroll',function() {
          for (let i = 0; i < numElements.length; i++) {
            if (isScrolledIntoView(numElements[i]) == true && animationStart == false) {
              console.log("count?");
              ImpactTextAnimated(numElements[i],duration);
              if ((i + 1) == numElements.length) {
                animationStart = true;
              }
            }
          }
        });
      }
    }
  }
};
if (!window.customElements.get("impact-text")) {
  window.customElements.define("impact-text", ImpactText);
}

function ImpactTextAnimated (item,duration) {
  let finalNum = +item.textContent;
  let counts = setInterval(updated, duration*1000/finalNum);
  let upto = 0;
  function updated () {
    item.innerHTML = ++upto;
    if (upto === finalNum) {
      clearInterval(counts);
    }
  }
};

function isScrolledIntoView(el) {
  var rect = el.getBoundingClientRect();
  var elemTop = rect.top;
  var elemBottom = rect.bottom;

  // Only completely visible elements return true:
  var isVisible = (elemTop - 5 >= 0) && (elemBottom - el.offsetHeight - 5 <= window.innerHeight);
  // Partially visible elements return true:
  //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
  return isVisible;
}





function throttle(callback) {
  let requestId = null, lastArgs;
  const later = (context) => () => {
    requestId = null;
    callback.apply(context, lastArgs);
  };
  const throttled = (...args) => {
    lastArgs = args;
    if (requestId === null) {
      requestId = requestAnimationFrame(later(this));
    }
  };
  throttled.cancel = () => {
    cancelAnimationFrame(requestId);
    requestId = null;
  };
  return throttled;
}

// js/common/behavior/scroll-progress.js
var ScrollProgress = class extends HTMLElement {
  connectedCallback() {
    this.scrolledElement.addEventListener("scroll", throttle(this._updateScrollProgress.bind(this)));
    if (window.ResizeObserver) {
      new ResizeObserver(this._updateScrollProgress.bind(this)).observe(this.scrolledElement);
    }

       this.scrolledElement.dispatchEvent(new Event('scroll', { bubbles: true }));

  }
  get scrolledElement() {
    return this._scrolledElement = this._scrolledElement || document.getElementById(this.getAttribute("observes"));
  }
  _updateScrollProgress() {    
    console.log('_updateScrollProgress');
    
    const scrollLeft = document.dir === "ltr" ? this.scrolledElement.scrollLeft : Math.abs(this.scrolledElement.scrollLeft), advancement = (scrollLeft + this.scrolledElement.clientWidth) / this.scrolledElement.scrollWidth;
    this.style.setProperty("--scroll-progress", Math.max(0, Math.min(advancement, 1)).toFixed(6));
  }
};
if (!window.customElements.get("scroll-progress")) {
  window.customElements.define("scroll-progress", ScrollProgress);
}



// js/sections/countdown-timer.js
var ShopTheLookCarousel = class extends HTMLElement {
  connectedCallback() {
    const _this = this;
    const parentEl = this.closest('.shopify-section');
    const slider_controls = parentEl.querySelectorAll('.shop-the-look__controls button');
    const page_dots = parentEl.querySelectorAll('page-dots button');
    const mobile_scroll_carousel = parentEl.querySelector('scroll-carousel');
        
    let sliderEl = _this
   let flickityIns =  new window.ThemeFlickity(_this, {
     cellAlign: 'left',
     wrapAround: true,
     pageDots: false,
     prevNextButtons: false

   });
    flickityIns.on( 'select', function( index ) {
      if(page_dots.length) {
         for(const dot of page_dots) {
        let dotIndex = dot.dataset.index * 1;
           if(dotIndex == index) {
             dot.setAttribute('aria-current','true');
           }else {
             dot.setAttribute('aria-current','false');
           }
      }
      }
    });
   
    if(slider_controls.length) {
     for (const btn of slider_controls) {
    
       btn.addEventListener('click',function(e) {
         e.preventDefault();
         let isAction = this.is;
         if(isAction == 'prev-button') {
           flickityIns.previous();
         } else {
            flickityIns.next();
         }
       });
}
    }
      if(page_dots.length) {
         for(const dot of page_dots) {

           dot.addEventListener('click', function (e) {
             e.preventDefault();
             let dotIndex = this.dataset.index * 1;
             flickityIns.select( dotIndex );

             if(mobile_scroll_carousel) {
               const horizontal_productArr= mobile_scroll_carousel.querySelectorAll('.horizontal-product');
               if(horizontal_productArr.length) {
                 let activeProductEl = horizontal_productArr[dotIndex];
                 if(activeProductEl) {
                   let scrollAmount = activeProductEl.offsetLeft;
                       mobile_scroll_carousel.scrollTo({ left: scrollAmount, behavior: "smooth" });
                 }
               }
             }

           });
        
        }
      }

    

    
  }

};
if (!window.customElements.get("effect-carousel")) {
  window.customElements.define("effect-carousel", ShopTheLookCarousel);
}

// ===== Transparent card video playback — Byteex =====
// Controls <video data-card-video data-playback="always|hover"> on product cards.
//   always : autoplay + loop while the card is in view (paused off-screen to save resources)
//   hover  : play on hover on desktop; autoplay-in-view on touch devices (no hover)
// Respects prefers-reduced-motion (skips autoplay; hover stays user-initiated).
(function () {
  var SELECTOR = "video[data-card-video]";
  var canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  // WebKit (Safari desktop + every iOS browser) ignores the alpha channel in
  // VP9/WebM and would render the video on a black box instead of falling back
  // to the product image. It only does transparency via HEVC (hvc1).
  var isWebkit = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  // True if this browser can actually show the video WITH transparency.
  function canRenderAlpha(video) {
    if (!isWebkit) return true; // Chromium/Firefox handle WebM alpha
    // Safari/iOS: only OK when an HEVC (non-webm) source is present and playable.
    var sources = video.querySelectorAll("source");
    for (var i = 0; i < sources.length; i++) {
      var type = sources[i].getAttribute("type") || "";
      if (type.indexOf("webm") === -1 && video.canPlayType(type.split(";")[0])) {
        return true;
      }
    }
    return false;
  }

  // iOS Chrome (CriOS) refuses muted autoplay until the first user gesture — a third-party-iOS-browser policy
  // that cannot be bypassed (no pure before-interaction autoplay). So when play() is rejected we queue the
  // video and a SINGLE, self-removing page-wide listener replays every queued video on the first tap / touch /
  // keypress, when iOS Chrome grants media playback. On a browse page that gesture happens within ~1s, so it
  // reads as autoplay. Desktop + iOS Safari autoplay muted video fine, so play() resolves and nothing queues.
  // `scroll` is intentionally not a trigger (not a user-activation event in WebKit; a touch-scroll fires
  // `touchstart` first, which is).
  var pendingPlay = [];
  var gestureBound = false;

  function bindGestureFallback() {
    if (gestureBound) return;
    gestureBound = true;
    var events = ["pointerdown", "touchstart", "keydown"];
    function fire() {
      gestureBound = false;
      var list = pendingPlay;
      pendingPlay = [];
      events.forEach(function (evt) { window.removeEventListener(evt, fire); });
      list.forEach(function (video) {
        var p = video.play();
        if (p && typeof p.catch === "function") p.catch(function () {});
      });
    }
    events.forEach(function (evt) { window.addEventListener(evt, fire, { passive: true }); });
  }

  function safePlay(video) {
    var promise = video.play();
    if (promise && typeof promise.catch === "function") {
      promise.catch(function () {
        // Autoplay blocked (iOS Chrome before the first gesture): retry on first user interaction.
        if (pendingPlay.indexOf(video) === -1) pendingPlay.push(video);
        bindGestureFallback();
      });
    }
  }

  var observer = ("IntersectionObserver" in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            safePlay(entry.target);
          } else {
            entry.target.pause();
          }
        });
      }, { rootMargin: "200px 0px" })
    : null;

  function autoplayInView(video) {
    if (reduceMotion) {
      // Honour the user's reduced-motion preference: keep the poster/product
      // image and stop any playback the `autoplay` attribute may have started.
      video.removeAttribute("autoplay");
      video.pause();
      try { video.currentTime = 0; } catch (e) {}
      return;
    }
    if (observer) {
      observer.observe(video);
    } else {
      safePlay(video);
    }
  }

  function setupHover(video) {
    // Hover target per surface: product card image, a multi-column item, or a collection-list item.
    // Falls back to the video's own parent so any future surface still gets hover playback.
    var card = video.closest(".product-item__image-wrapper, .multi-column__item, .list-collections__item") || video.parentElement;
    if (!card) return;
    card.addEventListener("mouseenter", function () { safePlay(video); });
    card.addEventListener("mouseleave", function () {
      video.pause();
      try { video.currentTime = 0; } catch (e) {}
    });
  }

  function initVideo(video) {
    if (video.dataset.cardVideoInit) return;
    video.dataset.cardVideoInit = "1";

    // No transparency support (e.g. WebM-only on Safari/iOS): drop the video so
    // the product image shows instead of an opaque black box.
    if (!canRenderAlpha(video)) {
      video.parentNode && video.parentNode.removeChild(video);
      return;
    }

    video.muted = true; // required for programmatic autoplay in most browsers

    // Mark the card so CSS can suppress the "secondary image on hover" swap
    // (it would briefly flash before/after the video). Only added here, i.e.
    // on browsers that actually play the video — Safari/iOS bailed out above,
    // so it keeps its secondary-image hover untouched.
    var wrapper = video.closest(".product-item__image-wrapper");
    if (wrapper) wrapper.classList.add("product-item__image-wrapper--has-card-video");

    // Block-section surfaces (Multi-column / Collection list): mark the image wrapper so CSS can
    // hide the underlying image — unlike the product-card video, .card-video has no opaque
    // background, so the image would otherwise show through the transparent video. JS-gated, so
    // Safari-WebM-only (video removed above) and no-JS keep the image as the visible fallback.
    var blockWrapper = video.closest(".multi-column__image-wrapper, .list-collections__item-image-wrapper");
    if (blockWrapper) blockWrapper.classList.add("is-card-video-active");

    var mode = video.getAttribute("data-playback") || "hover";
    if (mode === "always") {
      autoplayInView(video);
    } else if (mode === "hover") {
      if (canHover) {
        setupHover(video);
      } else {
        autoplayInView(video); // touch devices: behave like "always"
      }
    }
  }

  function scan(root) {
    if (!root) return;
    if (root.nodeType === 1 && root.matches && root.matches(SELECTOR)) {
      initVideo(root);
    }
    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll(SELECTOR), initVideo);
    }
  }

  function ready(fn) {
    if (document.readyState !== "loading") {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  ready(function () {
    scan(document);

    // Re-init cards injected after load (collection filtering, pagination, quick view).
    if ("MutationObserver" in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          Array.prototype.forEach.call(mutation.addedNodes, scan);
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  });
})();

